import React, { Component } from "react";

class StreamNotification extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			
		}
	}
 
	componentDidMount(){
		
	}
	
	
	render() {
		return (
			<div className="stream_notification">{this.props.notificationText}</div>		
	)}
}
export default StreamNotification;
